var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelevision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 40.375C15.625 40.0766 15.7435 39.7905 15.9545 39.5795C16.1655 39.3685 16.4516 39.25 16.75 39.25H39.25C39.5484 39.25 39.8345 39.3685 40.0455 39.5795C40.2565 39.7905 40.375 40.0766 40.375 40.375C40.375 40.6734 40.2565 40.9595 40.0455 41.1705C39.8345 41.3815 39.5484 41.5 39.25 41.5H16.75C16.4516 41.5 16.1655 41.3815 15.9545 41.1705C15.7435 40.9595 15.625 40.6734 15.625 40.375ZM41.4797 16.75L41.5338 16.7522C41.9542 16.7809 42.3651 16.8901 42.7443 17.074C43.0173 17.2011 43.2518 17.3983 43.4237 17.6455C43.5745 17.8705 43.75 18.2687 43.75 19V32.4797L43.7477 32.5338C43.7189 32.9541 43.6097 33.365 43.426 33.7443C43.2988 34.0172 43.1017 34.2517 42.8545 34.4237C42.6295 34.5745 42.2313 34.75 41.5 34.75H14.5203L14.4662 34.7477C14.0459 34.7189 13.635 34.6097 13.2558 34.426C12.9828 34.2988 12.7483 34.1017 12.5763 33.8545C12.4255 33.6295 12.25 33.2313 12.25 32.5V19.0202L12.2523 18.9662C12.2809 18.5458 12.3901 18.1349 12.574 17.7558C12.7012 17.4828 12.8983 17.2483 13.1455 17.0763C13.3705 16.9255 13.7687 16.75 14.5 16.75H41.4797ZM41.5 14.5H14.5C10 14.5 10 19 10 19V32.5C10 37 14.5 37 14.5 37H41.5C46 37 46 32.5 46 32.5V19C46 14.5 41.5 14.5 41.5 14.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevision);
export default __webpack_public_path__ + "static/media/television.ddf99348be4355a9d593631cd544eb51.svg";
export { ForwardRef as ReactComponent };